export default __webpack_public_path__ + "static/media/icon-import.e0488bb1.svg";